<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body p-3">
          <!-- <div class="card-title text-center">
            <h4>{{ $t("malware.history-upload") }}</h4>
          </div> -->
          <div class="search-form px-5">
            <div class="row">
              <div class="col-5 mt-2">
                <h5>{{ $t("malware.history-upload") }}</h5>
              </div>
              <div class="col-5 mt-2">
                <h5>{{ $t("malware.total-upload") }} : {{ total_upload }}</h5>
              </div>
              <div class="col-2 text-right">
                <b-button
                  variant="primary"
                  class="btn-block"
                  v-b-toggle="'history-upload'"
                >
                  <i class="bx bx-filter font-size-16 align-middle mr-1"></i>
                  <span class="d-xl-inline d-lg-none d-md-none d-sm-none">{{
                    $t("malware.more-details")
                  }}</span>
                </b-button>
              </div>
              <div class="col-12">
                <b-collapse id="history-upload" class="mt-1">
                  <hr class="mt-4 mb-0" />
                  <div class="py-4">
                    <div class="row">
                      <div class="row mt-4 px-2">
                        <div class="col-sm-12 col-md-6">
                          <div
                            id="tickets-table_length"
                            class="dataTables_length"
                          >
                            <label class="d-inline-flex align-items-center">
                              {{ $t("table.show_label") }}&nbsp;&nbsp;
                              <b-form-select
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                                class="mx-1"
                              ></b-form-select
                              >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                            </label>
                          </div>
                        </div>
                        <!-- Search -->
                        <div class="col-sm-12 col-md-6">
                          <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                          >
                            <label class="d-inline-flex align-items-center">
                              {{ $t("table.search_label") }}:
                              <b-form-input
                                v-model="filter"
                                type="search"
                                :placeholder="$t('navbar.search.text')"
                                class="form-control form-control-sm ml-2"
                              ></b-form-input>
                            </label>
                          </div>
                        </div>
                        <!-- End search -->
                      </div>
                      <!-- Table -->
                      <div class="table-responsive mb-0 px-2">
                        <b-table
                          :items="tableData"
                          :fields="fields"
                          responsive="sm"
                          :per-page="perPage"
                          :current-page="currentPage"
                          :sort-desc.sync="sortDesc"
                          :filter="filter"
                          :filter-included-fields="filterOn"
                          @filtered="onFiltered"
                        >
                          <template #cell(no)="row">
                            <span>{{ row.index + 1 }}</span>
                          </template>
                          <template #cell(created_at)="row">
                            <span>{{ formatDate(row.item.created_at) }}</span>
                          </template>
                          <template #cell(running_vm)="row">
                            <div v-if="row.item.sandbox == 'ahn_lab'">
                              <span v-if="row.item.running_vm == 'vm1'"
                                >Windows XP</span
                              >
                              <span v-if="row.item.running_vm == 'vm2'"
                                >Windows 7</span
                              >
                              <span v-if="row.item.running_vm == 'vm3'"
                                >Windows 10</span
                              >
                              <span v-if="row.item.running_vm == 'vm4'"
                                >Windows 11</span
                              >
                            </div>
                            <div v-if="row.item.sandbox == 'cp_lab'">
                              <span class="mr-2">Windows XP</span>
                              <span>Windows 7</span>
                            </div>
                          </template>
                          <template #cell(status)="row">
                            <span
                              class="badge badge-info p-1 px-1 badge-md rounded"
                              variant="secondary"
                              v-if="row.item.status == 0"
                            >
                              On Prosess</span
                            >
                            <span
                              class="badge badge-success p-1 px-1 rounded"
                              v-else-if="row.item.status == 1"
                            >
                              Done</span
                            >
                          </template>
                        </b-table>
                      </div>
                      <div class="row px-2" v-if="rows > 10">
                        <div class="col-2">
                          <label class="d-inline-flex align-items-center">
                            Page
                            <b-form-input
                              v-model="currentPage"
                              placeholder="Page"
                              class="form-control w-10 form-control ml-2"
                            ></b-form-input>
                          </label>
                        </div>
                        <div class="col-10 text-right" v-if="rows > 10">
                          <div
                            class="dataTables_paginate paging_simple_numbers float-right"
                          >
                            <ul
                              class="pagination pagination-rounded mb-0"
                              :class="
                                theme == 'dark'
                                  ? 'custom-paginate-dark'
                                  : 'custom-paginate'
                              "
                            >
                              <!-- pagination -->
                              <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                              ></b-pagination>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QueueService from "@/helpers/queue.service";
import MalwareService from "@/helpers/malware.service";
import PreferencesServices from "@/helpers/preferences.service";
import ElasticServices from "@/helpers/elastic.service";
import moment from "moment";
import StatisticsService from "@/helpers/statistics.service";
import detailMalwareVue from "./detail-malware.vue";
import Helpers from "@/helpers/auxiliary.function";

/**
 * Projects-grid component
 */
export default {
  props: {
    runQueue: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      total_upload: 0,
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      theme: localStorage.getItem("theme") ?? "light",
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },

        {
          key: "sandbox",
          sortable: true,
          label: "Sandbox ",
        },
        {
          key: "filename",
          sortable: true,
          label: this.$t("malware.file-name"),
        },
        {
          key: "filetype",
          sortable: true,
          label: this.$t("malware.file-type"),
        },
        {
          key: "running_vm",
          sortable: true,
          label: "Running VM",
        },

        {
          key: "created_at",
          sortable: true,
          label: this.$t("malware.upload-date"),
        },
        {
          key: "status",
          sortable: true,
          label: this.$t("malware.status"),
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    getHistoryUpload() {
      let ferr = 0;
      StatisticsService.getHistoryReports()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getTotal();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            console.log("res", response.data.data);
            this.total_upload = response.data.data.length;
            response.data.data.forEach((val, index) => {
              const data = {
                no: index + 1,
                id_queue: val.id_queue,
                sandbox: val.sandbox,
                running_vm: val.running_vm,
                id_malware: val.id_malware,
                md5: val.md5,
                filename: val.filename,
                filetype: val.filetype,
                upload_by: val.upload_by,
                status: val.status,
                analysis_time: val.analysis_time,
                created_at: val.created_at,
                updated_at: val.updated_at,
              };
              this.tableData.push(data);
              // this.loading = false;
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getTotal();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatDate(val) {
      return moment(val).format("YYYY-MM-DD, hh:mm");
    },
  },
  mounted() {
    this.getHistoryUpload();
  },
};
</script>
<style>
.upload-setting {
  border: solid 3px #052a38;
  border-radius: 5px;
}
.pagination-rounded .page-link {
  outline: none !important;
  margin: 0 2px;
  border: 1px solid #ced4da;
}
.custom-paginate-dark .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #022b3a !important;
}
.custom-paginate .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #eff2f7 !important;
}
</style>
